import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import HomePage from "./pages/home/HomePage";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import UserRegister from "./pages/user/UserRegister";
import Listing from "./pages/listing/Listing";
import DetailPage from "./pages/detailPage/DetailPage";
import UserLayout from "./layouts/UserLayout";
import UserProfile from "./pages/userPages/UserProfile";
import UserChat from "./pages/userPages/UserChat";
import UserTours from "./pages/userPages/UserTours";
import UserBookmarks from "./pages/userPages/UserBookmarks";
import AgentRegister from "./pages/agent/AgentRegister";
import AdvertiserRegister from "./pages/advertiser/AdvertiserRegister";
import AgentLayout from "./layouts/AgentLayout";
import AgentProfile from "./pages/agentPages/AgentProfile";
import Requests from "./pages/agentPages/AgentLeads";
import AdvertiserLayout from "./layouts/AdvertiserLayout";
import BeforeBegin from "./pages/advertiser/BeforeBegin";
import { createContext } from "react";
import ScheduleTour from "./pages/schedule_a_tour/ScheduleTour";
import MakeOffer from "./pages/make_an_offer/MakeOffer";
import AdvertiserProfile from "./pages/advertiserPage/AdvertiserProfile";
import UserOffers from "./pages/userPages/UserOffers";
import Transactional from "./pages/transactional/Transactional";
import LandingAgent from "./pages/landing/LandingAgent";
import LicenseInfo from "./pages/landing/LicenseInfo";
import LicenseInfoTwo from "./pages/landing/LicenseInfoTwo";
import LendingAgentLayout from "./layouts/LendingAgentLayout";
import LaProfile from "./pages/laPages/LaProfile";
import ForgotPassword from "./pages/forgotpassword/ForgotPassword";
import AdminRegister from "./pages/admin/AdminRegister";
import AdminLayout from "./layouts/AdminLayout";
import AdminProfile from "./pages/adminPages/AdminProfile";
import AgentLeads from "./pages/agentPages/AgentLeads";
import LendingLeads from "./pages/laPages/LendingLeads";

import ListingLeads from "./pages/agentPages/ListingLeads";
import TcLeads from "./pages/agentPages/TcLeads";
import AdvertiserDetails from "./pages/advertiser/advertiserdetailPage/AdvertiserDetails";
import Contact from "./pages/contact/Contact";
import ManageAds from "./pages/advertiserPage/ManageAds";
import Checkout from "./pages/checkout/Checkout";
import Success from "./pages/success/Success";
import AdvCheckout from "./pages/adv-checkout/AdvCheckout";
import ListingChat from "./pages/agentPages/ListingChat";
import ShowingChat from "./pages/agentPages/ShowingChat";
import TcChat from "./pages/agentPages/TcChat";
import AgentStatus from "./pages/adminPages/AgentStatus";
import AllUsers from "./pages/adminPages/AllUsers";
import AllHomes from "./pages/adminPages/AllHomes";
import AllOffers from "./pages/adminPages/AllOffers";
import AddAdmin from "./pages/adminPages/AddAdmin";
import LaChat from "./pages/laPages/LaChat";
import AdvChat from "./pages/advertiserPage/AdvChat";
import AdminChat from "./pages/adminPages/AdminChat";
import Payments from "./pages/adminPages/Payments";
import AddhypeChat from "./pages/addhypePages/AddhypeChat";
import AddhypeProfile from "./pages/addhypePages/AddhypeProfile";
import AddhypeLayout from "./layouts/AddhypeLayout";
import AddhypeAdv from "./pages/addhypePages/AddhypeAdv";
import AdminAdv from "./pages/adminPages/AdminAdv";
import BobChat from "./pages/adminPages/BobChat";
import AgentZipCodes from "./pages/agentPages/AgentZipCodes";
import Verified from "./pages/verified/Verified";
import ChangePassword from "./pages/userPages/ChangePassword";
import AgentPassword from "./pages/agentPages/AgentPassword";
import LaPassword from "./pages/laPages/LaPassword";
import AdvertiserPassword from "./pages/advertiserPage/AdvertiserPassword";
import AdminPassword from "./pages/adminPages/AdminPassword";
import AdvBusiness from "./pages/advertiserPage/AdvBusiness";
import LaLicense from "./pages/laPages/LaLicense";
import { HelmetProvider } from 'react-helmet-async';
import AdvStatus from "./pages/adminPages/AdvStatus";
import ZipCodes from "./pages/adminPages/ZipCodes";
import ZipCodeDetail from "./pages/adminPages/ZipCodeDetail";
import AdvZipCodes from "./pages/advertiserPage/AdvZipCodes";
// Create a component to handle scrolling to the top
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, [location.pathname]); // Trigger the effect when the pathname changes

  return null; // This component doesn't render anything
};

const ProfileUpdate = createContext();
const PathContext = createContext();
function App() {
  const [path, setPath] = useState("nav");
  const [profileUpdateState, setProfileUpdateState] = useState(0);
 
  return (
    <HelmetProvider>
    <PathContext.Provider value={{ path, setPath }}>
      <ProfileUpdate.Provider
        value={{ profileUpdateState, setProfileUpdateState }}
      >
        <div className="App">
          <BrowserRouter>
          <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/user-register" element={<UserRegister />} />
              <Route path="/success" element={<Success />} />
              <Route path="/verified" element={<Verified />} />
              <Route path="/advertiser-details" element={<AdvertiserDetails />} />
              <Route path="/contact-us" element={<Contact />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/advertiser-checkout" element={<AdvCheckout />} />
              <Route path="/schedule-tour" element={<ScheduleTour />} />
              <Route path="/make-offer" element={<MakeOffer />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/agent-register" element={<AgentRegister />} />
              <Route path="/tc-register" element={<Transactional />} />
              <Route path="/la-register" element={<LandingAgent />} />
              <Route path="/admin" element={<AdminRegister />} />
              <Route
                path="/advertiser-register"
                element={<AdvertiserRegister />}
              />
              <Route path="/zipcode-listing" element={<Listing />} />
              <Route path="/listing-detail" element={<DetailPage />} />
              <Route path="/before-begin" element={<BeforeBegin />} />
              <Route path="/license-info" element={<LicenseInfo />} />
              <Route path="/license-info-page-2" element={<LicenseInfoTwo />} />
              <Route path="/user-auth" element={<UserLayout />}>
                <Route path="profile" element={<UserProfile />} />
                <Route path="chat" element={<UserChat />} />
                <Route path="tours" element={<UserTours />} />
                <Route path="offers" element={<UserOffers />} />
                <Route path="bookmarks" element={<UserBookmarks />} />
                <Route path="password" element={<ChangePassword />} />
              </Route>

              <Route path="/admin-auth" element={<AdminLayout />}>
                <Route path="profile" element={<AdminProfile />} />
                <Route path="agent-status" element={<AgentStatus />} />
                <Route path="adv-status" element={<AdvStatus />} />
                <Route path="payments" element={<Payments />} />
                <Route path="admin-adv" element={<AdminAdv />} />
                <Route path="admin-zips" element={<ZipCodes />} />
                <Route path="zip-detail" element={<ZipCodeDetail />} />
                <Route path="all-users" element={<AllUsers />} />
                <Route path="all-houses" element={<AllHomes />} />
                <Route path="all-offers" element={<AllOffers />} />
                <Route path="add-admin" element={<AddAdmin />} />
                <Route path="admin-chat" element={<AdminChat/>} />
                <Route path="sub-admin-chat" element={<BobChat/>} />
                <Route path="password" element={<AdminPassword/>} />
              </Route>
              <Route path="/addhype-auth" element={<AddhypeLayout />}>
                <Route path="profile" element={<AddhypeProfile />} />
                <Route path="adv" element={<AddhypeAdv />} />
             
                <Route path="addhype-chat" element={<AddhypeChat/>} />
              </Route>
              <Route path="/agent-auth" element={<AgentLayout />}>
                <Route path="profile" element={<AgentProfile />} />
                <Route path="listing-leads" element={<ListingLeads />} />
                <Route path="showing-leads" element={<AgentLeads />} />
                <Route path="tc-leads" element={<TcLeads />} />
                <Route path="listing-chat" element={<ListingChat />} />
                <Route path="showing-chat" element={<ShowingChat />} />
                <Route path="tc-chat" element={<TcChat />} />
                <Route path="zip-codes" element={<AgentZipCodes />} />
                <Route path="password" element={<AgentPassword />} />
              </Route>
              <Route path="/la-auth" element={<LendingAgentLayout />}>
                <Route path="profile" element={<LaProfile />} />
                <Route path="leads" element={<LendingLeads />} />
                <Route path="la-chat" element={<LaChat />} />
                <Route path="password" element={<LaPassword />} />
                <Route path="license" element={<LaLicense />} />
              </Route>
              <Route path="/advertiser-auth" element={<AdvertiserLayout />}>
                <Route path="profile" element={<AdvertiserProfile />} />
                <Route path="manage-ads" element={<ManageAds />} />
                <Route path="adv-chat" element={<AdvChat />} />
                <Route path="password" element={<AdvertiserPassword />} />
                <Route path="business" element={<AdvBusiness />} />
                <Route path="manage-zip" element={<AdvZipCodes />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </ProfileUpdate.Provider>
    </PathContext.Provider>
    </HelmetProvider>

  );
}

export default App;
export { PathContext, ProfileUpdate };
